<!-- Events -->
<!-- itemCreated -->

<template>
  <v-row
    v-if="swUpdateAvail || swUpdateReady"
    class="d-flex flex-column"
  >
    <v-card
      v-if="downloadingUpdate"
      flat
      class="mx-auto card-full-width d-flex flex-column"
    >
      <v-progress-linear
        indeterminate
        color="yellow"
      ></v-progress-linear>
    </v-card>
    <v-card
      v-if="swUpdateReady"
      flat
      class="mx-auto card-full-width d-flex flex-column"
    >
      <v-card
        flat
        class="card-full-width mx-auto"
      >
        <v-alert
          text
          class="mx-auto"
          width="95%"
          type="info"
        >
          <v-col
            style="color: #4e4c4c"
            class="grow section-bullets"
          >
            The website has been updated since your last vist. Click to update.
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn
              tile
              large
              color="secondary"
              @click="doUpdate"
            >
              Update
            </v-btn>
          </v-col>
        </v-alert>
      </v-card>
    </v-card>
  </v-row>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    SW_DO_UPDATE,
  } from '../../store/actions.types'

  export default {
    name: 'swUpdateBar',

    inheritAttrs: false,
    data: function () {
      return {
        debugMode: `${process.env.VUE_APP_DEBUG}`,
      }
    },
    watch: {
      swUpdateReady (n, o) {
        if (n) {
          this.doUpdate()
        }
      },
    },
    computed: {
      ...mapGetters(['swUpdateAvail', 'swUpdateReady']),
      downloadingUpdate: function () {
        return this.swUpdateAvail && !this.swUpdateReady
      },
    },
    async created () {
    },
    methods: {
      ...mapActions({
        doUpdate: SW_DO_UPDATE,
      }),
    },

  }
</script>

<style>
</style>
